/**
 * @功能名称: axios网络库，公共逻辑封装
 * @文件名称: ajaxH5.js
 * @Date: 2018/8/2 上午10:37.
 * @Author: liux
 * @Copyright(C): 2014-2018 X-Financial Inc.   All rights reserved.
 */
import axios from 'axios';
import qs from 'qs';
import {extend} from '../helper/utils';

import getQueryString from '../helper/getQueryString';
import getAppInfo from '../helper/getAppInfo';
import getAjaxSign from './getAjaxSign';
import replaceDomain from '../xyHelper/replaceDomain'
import translateCode from './translateCode'
var appinfo = getAppInfo();
var source = getQueryString('source') || getQueryString('activity_source')

export default function(store, opt = {}) {
  opt = extend({
    baseHost: location.origin,
    timeout: 30000,
    logout: -4,
    data: {},
    msg:'网络不给力啊，请您检查一下网络再试试吧',
    slientError: false,
    withCredentials: true
  }, opt);
  axios.defaults.baseURL = opt.baseHost;
  axios.defaults.timeout = opt.timeout;
  axios.defaults.withCredentials = opt.withCredentials;
  var commonData = Object.assign({source}, opt.data);
  if (appinfo.app) {
    commonData.language = appinfo.language;
    commonData.mac_id = appinfo.macId;
    commonData.os = appinfo.os;
    commonData.os_version = appinfo.osVersion;
    commonData.soft_version = appinfo.softVersion;
  } else {
    commonData.os = 'h5';
    commonData._srcid = source;
  }

  axios.defaults.transformRequest = [
    function(data = {}) {
      // isPayloadData:true时Content-Type为application/json 
      if(data.isPayloadData) {
        delete data.isPayloadData
        return JSON.stringify(data)
      } else {
        return qs.stringify(data)
      }
    }],
    axios.interceptors.request.use(function(config) {
      if (!config.slient) {
        store.commit('ajaxState', {flag: store.state.ajaxState.flag + 1});
      }
      if(config.data && config.data.isPayloadData) {
        config.headers['Content-Type'] = 'application/json'
      }
      // xiaoying domain自动切换
      config.url = replaceDomain(config.url)
      var signData = Object.assign(
        {ut: Math.floor((new Date()).getTime() / 1000)}, commonData,
        config.data);
      if (appinfo.app) {
        return new Promise(function(resolve) {
          getAjaxSign(signData, (sign) => {
            signData.sign = sign; //获取验签
            config.data = Object.assign({}, config.data, signData);
            resolve(config);
          });
        });
      } else {
        config.data = Object.assign({}, config.data, signData);
        return config;
      }
    });

  axios.interceptors.response.use(function(response) {
    if (!response.config.slient) {
      setTimeout(function () {
        // 弹窗消失的执行放在下一次异步队列，连着的两次网络请求弹窗就不会闪
        store.commit('ajaxState', {flag: store.state.ajaxState.flag - 1});
      },0)
    }
    // 对有些错误码进行转换
    let data = translateCode(response.data, response.config.url)
    if (data.errcode == opt.logout) {
      store.commit('loginState', {loginState: false});
    }
    return data;
  }, function(error) {
    setTimeout(function () {
      store.commit('ajaxState', {flag: store.state.ajaxState.flag - 1});
    },0)
    if(error.config.slientError || opt.slientError){
      return Promise.reject({errcode:-500,errstr:opt.msg,error:error});
    }
    if (window.xy_App) {
      window.xy_App.toast(opt.msg);
    } else {
      alert(opt.msg);
    }
    return Promise.reject(error);
  });
}
